import http from 'hub-http/clients/apiClient';
export default class UsersSearchApi {
  static searchUsers(request, includeDeactivatedUsers = false) {
    return http.put('users-search/v1/users-search/app/search', {
      data: {
        offset: request.offset || 0,
        limit: request.limit || 50,
        searchQuery: request.searchQuery || '',
        mustMatchUserIds: request.mustMatchUserIds || [],
        mustNotMatchUserIds: request.mustNotMatchUserIds || [],
        onlyVisibleUsers: true,
        includePartnerUsers: true,
        includeDeactivatedUsers,
        onlyConfirmedUsers: false
      }
    });
  }
}